import { useAppSelector } from "@application/store/useStore";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
export default function QuotationTabsHelpers() {
    const { unchangedQuotation } = useAppSelector((state) => state.quotation);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formData, setFormData] = useState({
        quotationNumber: "",
        workOrderId: 0,
        workOrderName: "",
        debtorId: 0,
        debtorName: "",
        note: "",
        dateSent: null,
        statusId: 1,
    });
    const [errors, setErrors] = useState({
        quotationNumber: "",
        workOrderId: "",
        workOrderName: "",
        debtorId: "",
        debtorName: "",
        note: "",
        date: "",
    });
    useEffect(() => {
        if (!errors.quotationNumber && !errors.workOrderId && !errors.debtorName) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: '', // Clear the error for this field on every change
        }));
    };
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleTimeCalendarChange = (fieldName, value) => {
        const timeStringValue = value?.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: timeStringValue
        }));
    };
    useEffect(() => {
        checkBoldFieldsQuotation();
        checkUnchangedFieldsQuotation();
    }, [formData, unchangedQuotation]);
    const validateForm = () => {
        const newErrors = {
            quotationNumber: "",
            workOrderId: "",
            workOrderName: "",
            debtorId: "",
            debtorName: "",
            note: "",
            date: "",
        };
        if (formData.quotationNumber.replaceAll('@', '').trim() == "") {
            newErrors.quotationNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.workOrderId <= 0) {
            newErrors.workOrderId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.debtorId <= 0 || formData.debtorName?.trim() == "") {
            newErrors.debtorName = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkUnchangedFieldsQuotation = () => {
        if (unchangedQuotation && formData && id) {
            let isInfoTabUnsaved = false;
            let isNotitiesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedQuotation.quotationNumber != formData.quotationNumber ||
                unchangedQuotation.workOrderId != formData.workOrderId ||
                unchangedQuotation.debtorId != formData.debtorId ||
                unchangedQuotation.shippingMethodId != formData.shippingMethodId ||
                moment(unchangedQuotation.dateSent).format('YYYY-MM-DD') != moment(formData.dateSent).format('YYYY-MM-DD') ||
                moment(unchangedQuotation.deliveryDate).format('YYYY-MM-DD') != moment(formData.deliveryDate).format('YYYY-MM-DD')) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (unchangedQuotation.note !== formData.note) {
                isNotitiesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotitiesTabUnsaved);
        }
    };
    const checkBoldFieldsQuotation = () => {
        if (!formData.quotationNumber.includes('@@') || formData.workOrderId || formData.debtorId || formData.dateSent) {
            setIsInfoTabBold(true);
        }
        else {
            setIsInfoTabBold(false);
        }
        if (formData.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        handleFieldChange,
        handleToggelButtonChange,
        handleCalendarChange,
        handleTimeCalendarChange,
        validateForm,
        formData,
        setFormData,
        errors,
        infoTabErrorBorderColor,
        isInfoTabUnsaved,
        isNotesTabUnsaved,
        isInfoTabBold,
        isNotesTabBold
    };
}
